// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-group {\n  flex-wrap: unset !important;\n}\n.vdp-datepicker {\n  width: 100%;\n}\n.are-clsapc-input {\n  display: flex;\n  justify-content: center;\n  margin: 30px 0;\n  color: red;\n}\n.are-clsapc-input > .blk-clsapc-input {\n  width: 92%;\n}\n.are-clsapc-input .btn-add-ca {\n  align-self: flex-start;\n}\n@media screen and (max-width: 768px) {\n.are-clsapc-input > .blk-clsapc-input {\n    width: 102%;\n}\n}", ""]);
// Exports
module.exports = exports;
